const API = process.env.REACT_APP_BACKEND_URL;

function getToken() {
  return localStorage.getItem('leprotocol_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { headers, ...options });
  if (res.status === 401) {
    // Only clear auth for actual auth endpoints, don't reload
    if (path.includes('/auth/me')) {
      localStorage.removeItem('leprotocol_token');
      localStorage.removeItem('leprotocol_user');
    }
    throw new Error('Session expired');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `API ${res.status}`);
  }
  return res.json();
}

export const api = {
  health: () => request('/api/health'),
  // Auth
  register: (data) => request('/api/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  login: (data) => request('/api/auth/login', { method: 'POST', body: JSON.stringify(data) }),
  getMe: () => request('/api/auth/me'),
  checkUsername: (username) => request(`/api/auth/check-username/${encodeURIComponent(username)}`),
  // Users
  getUser: (id) => request(`/api/users/${id}`),
  updateUser: (id, data) => request(`/api/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  // Workout logs
  saveWorkoutLog: (data) => request('/api/workout-logs', { method: 'POST', body: JSON.stringify(data) }),
  getWorkoutLogs: (userId, date) => request(`/api/workout-logs/${userId}${date ? `?date=${date}` : ''}`),
  // Meals
  saveMealLog: (data) => request('/api/meal-logs', { method: 'POST', body: JSON.stringify(data) }),
  getMealLogs: (userId, date) => request(`/api/meal-logs/${userId}${date ? `?date=${date}` : ''}`),
  // Body
  saveBodyMeasurement: (data) => request('/api/body-measurements', { method: 'POST', body: JSON.stringify(data) }),
  getBodyMeasurements: (userId) => request(`/api/body-measurements/${userId}`),
  // PRs
  savePR: (data) => request('/api/prs', { method: 'POST', body: JSON.stringify(data) }),
  getPRs: (userId) => request(`/api/prs/${userId}`),
  // Supplements
  saveSupplements: (data) => request('/api/supplements', { method: 'POST', body: JSON.stringify(data) }),
  getSupplements: (userId, date) => request(`/api/supplements/${userId}${date ? `?date=${date}` : ''}`),
  // Checklist
  saveChecklist: (data) => request('/api/checklist', { method: 'POST', body: JSON.stringify(data) }),
  getChecklist: (userId, date) => request(`/api/checklist/${userId}${date ? `?date=${date}` : ''}`),
  // Ratings
  saveRating: (data) => request('/api/ratings', { method: 'POST', body: JSON.stringify(data) }),
  getRatings: (userId) => request(`/api/ratings/${userId}`),
  // Hip fix
  saveHipFix: (data) => request('/api/hip-fix', { method: 'POST', body: JSON.stringify(data) }),
  getHipFix: (userId) => request(`/api/hip-fix/${userId}`),
  // Water
  saveWater: (data) => request('/api/water', { method: 'POST', body: JSON.stringify(data) }),
  getWater: (userId, date) => request(`/api/water/${userId}${date ? `?date=${date}` : ''}`),
  // Achievements
  getAchievements: (userId) => request(`/api/achievements/${userId}`),
  // Custom Programs
  generatePlan: (data) => request('/api/generate-plan', { method: 'POST', body: JSON.stringify(data) }),
  uploadProgram: async (formData) => {
    const token = getToken();
    const headers = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const res = await fetch(`${API}/api/upload-program`, { method: 'POST', headers, body: formData });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.detail || `API ${res.status}`); }
    return res.json();
  },
  getCustomProgram: (userId) => request(`/api/custom-program/${userId}`),
  // Demo
  seedDemo: () => request('/api/seed-demo', { method: 'POST' }),
};
